import * as moment from 'moment';

export default function convertDateTimeToDeadlineHours(datetime) {
    const diff = moment(datetime).diff(new Date());
    const hours = (diff > 0) ? Math.ceil(diff / 1000 / 60 / 60) : 0;
    return hours;
}
